/* i18n */
if(typeof window!=="undefined"&&typeof window.TR==="undefined"){window.TR=function(k,v){if(window.GS&&GS.t)return GS.t(k,v);if(window.GSUX_LANG&&window.GSUX_LANG[k]!=null)return window.GSUX_LANG[k];return k;};}
var TR=window.TR;
/* i18n helper (global so every IIFE sees it) */
if(typeof window!=="undefined" && typeof window.T==="undefined"){window.T=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var T=window.T;
/* settings.js — account settings (profile, avatar, billing, invoices, address, email reports, delete) */
(function(){
  'use strict';
  var g=function(k){return GSUI.gs(k)};
  function show(el,on){ if(el) el.classList.toggle('d-none',!on) }
  function initial(s){ return (s||'?').charAt(0).toUpperCase() }
  function avUrl(p){ return p ? ((GS.apiBase||'')+p) : '' }
  function money(c,cur){ return (cur||'USD')==='USD'?('$'+((c||0)/100).toFixed(2)):(((c||0)/100).toFixed(2)+' '+cur) }
  function setAvatarEls(url,name,email){
    var ini=initial(name||email);
    // left panel + preview
    var av=g('set-av'), pv=g('avatar-prev');
    [av,pv].forEach(function(el){ if(!el)return; el.innerHTML=url?('<img src="'+url+'" alt="" style="width:100%;height:100%;border-radius:50%;object-fit:cover">'):ini; });
    show(g('avatar-remove'), !!url);
    // topbar avatar + menu (if present)
    var ta=g('avatar-initial'); if(ta) ta.innerHTML=url?('<img src="'+url+'" alt="">'):ini;
    var ma=g('menu-avatar'); if(ma) ma.innerHTML=url?('<img src="'+url+'" alt="" style="width:100%;height:100%;border-radius:50%;object-fit:cover">'):ini;
  }

  /* ---- section switching ---- */
  function initNav(){
    GSUI.qa('.gs-settings-nav a[data-sec]').forEach(function(a){
      a.addEventListener('click', function(e){ e.preventDefault();
        GSUI.qa('.gs-settings-nav a[data-sec]').forEach(function(x){x.classList.remove('on')}); a.classList.add('on');
        GSUI.qa('.gs-settings-body section[data-panel]').forEach(function(s){ s.hidden = s.dataset.panel!==a.dataset.sec });
        if(a.dataset.sec==='invoices') loadInvoices();
        if(a.dataset.sec==='billing') loadBilling();
        if(a.dataset.sec==='address') loadAddress();
        if(a.dataset.sec==='reports') loadReports();
        if(a.dataset.sec==='tracking') loadTracking();
        if(a.dataset.sec==='counter') loadCounter();
        if(a.dataset.sec==='insights') loadInsights();
        if(a.dataset.sec==='affiliate') loadAffiliate();
      });
    });
  }

  /* ---- profile + avatar ---- */
  function loadProfile(){
    var u=GS.user||{};
    var name=u.name||'', email=u.email||'';
    if(g('set-name')) g('set-name').textContent=name||email.split('@')[0];
    if(g('set-email')) g('set-email').textContent=email;
    if(g('profile-name')) g('profile-name').value=name;
    if(g('profile-email')) g('profile-email').value=email;
    if(g('profile-tz')) g('profile-tz').value=u.timezone||'UTC';
    // The clock format comes from the account, not the browser. It used to live only in
    // localStorage while the server did the formatting, so choosing 24-hour changed nothing.
    var tf=g('profile-timefmt'); if(tf) tf.value = (u.time_format==='12') ? '12' : '24';
    var ps=g('profile-paper'); if(ps && u.paper_size) ps.value = u.paper_size;
    setAvatarEls(avUrl(u.avatar), name, email);
    if(g('del-expect')) g('del-expect').textContent = name || email;
  }
  async function uploadAvatar(file){
    var err=g('avatar-error'); show(err,false);
    if(!file || !/^image\//.test(file.type)){ err.textContent='Please choose an image file.'; show(err,true); return; }
    if(file.size>2*1024*1024){ err.textContent='Image must be under 2 MB.'; show(err,true); return; }
    var fd=new FormData(); fd.append('avatar',file);
    var res=await fetch((GS.apiBase||'')+'/me/avatar',{method:'POST',credentials:'include',headers:GS.csrf?{'X-CSRF-Token':GS.csrf}:{},body:fd});
    var data=null; try{data=await res.json()}catch(e){}
    if(res.ok && data && data.avatar){ GS.user.avatar=data.avatar; setAvatarEls(avUrl(data.avatar),GS.user.name,GS.user.email); }
    else { err.textContent = (data&&data.error==='too_large')?'Image must be under 2 MB.':(data&&data.error==='bad_type')?'Unsupported image type.':TR('js.upload_failed'); show(err,true); }
  }
  function initAvatar(){
    var drop=g('avatar-drop'), input=g('avatar-input');
    if(!drop) return;
    g('avatar-browse') && g('avatar-browse').addEventListener('click',function(e){e.stopPropagation(); input.click()});
    drop.addEventListener('click',function(){ input.click() });
    input.addEventListener('change',function(){ if(input.files[0]) uploadAvatar(input.files[0]) });
    ['dragenter','dragover'].forEach(function(ev){ drop.addEventListener(ev,function(e){e.preventDefault();drop.classList.add('over')}) });
    ['dragleave','drop'].forEach(function(ev){ drop.addEventListener(ev,function(e){e.preventDefault();drop.classList.remove('over')}) });
    drop.addEventListener('drop',function(e){ var f=e.dataTransfer.files[0]; if(f) uploadAvatar(f) });
    g('avatar-remove') && g('avatar-remove').addEventListener('click',async function(e){ e.stopPropagation();
      await GS.api('/me/avatar',{method:'DELETE'}); GS.user.avatar=null; setAvatarEls('',GS.user.name,GS.user.email); });
  }
  function initProfileSave(){
    var b=g('profile-save'); if(!b) return;
    b.addEventListener('click',async function(){ show(g('profile-ok'),false);
      var name=g('profile-name').value; var tz=(g('profile-tz')||{}).value||'UTC';
      var tf=((g('profile-timefmt')||{}).value==='12')?'12':'24';
      var ps=(g('profile-paper')||{}).value||'auto';
      var r=await GS.api('/me/profile',{method:'POST',body:JSON.stringify({name:name,timezone:tz,time_format:tf,paper_size:ps})});
      if(r.ok){ GS.user.name=name; GS.user.timezone=tz; GS.tz=tz; loadProfile(); show(g('profile-ok'),true); if(g('menu-name'))g('menu-name').textContent=name||GS.user.email; } });
    var td=g('tz-detect'); if(td&&!td._w){ td._w=1; td.addEventListener('click',async function(){
      var tz='UTC'; try{tz=Intl.DateTimeFormat().resolvedOptions().timeZone||'UTC'}catch(e){}
      if(g('profile-tz'))g('profile-tz').value=tz;
      var r=await GS.api('/me/profile',{method:'POST',body:JSON.stringify({name:(g('profile-name')||{}).value||'',timezone:tz})});
      if(r.ok){ if(GS.user){GS.user.timezone=tz;} GS.tz=tz; show(g('profile-ok'),true); setTimeout(function(){show(g('profile-ok'),false)},2500); } }); }
    var pb=g('pw-save'); if(pb) pb.addEventListener('click',async function(){ show(g('pw-error'),false); show(g('pw-ok'),false);
      var r=await GS.api('/me/password',{method:'POST',body:JSON.stringify({current:g('pw-current').value,new:g('pw-new').value})});
      if(r.ok){ show(g('pw-ok'),true); g('pw-current').value=''; g('pw-new').value=''; }
      else { g('pw-error').textContent=(r.data&&r.data.error==='wrong_current')?'Current password is incorrect.':(r.data&&r.data.error==='weak')?'New password must be at least 10 characters.':T('st.could_not_update_password'); show(g('pw-error'),true); } });
  }

  /* ---- billing / invoices / address ---- */
  async function loadBilling(){
    var r=await GS.api('/me/billing'); if(!(r.ok&&r.data)) return; var d=r.data;
    if(g('bill-plan'))g('bill-plan').textContent=d.plan;
    if(g('bill-price'))g('bill-price').textContent=money(d.price_cents);
    if(g('bill-status'))g('bill-status').textContent=d.subscription?('Status: '+d.subscription.status):'';
    var ret=new URLSearchParams(location.search).get('billing');
    if(ret&&g('bill-ok')){ var ok=g('bill-ok'); ok.textContent=ret==='success'?'Your plan is now active. Thank you!':(ret==='cancel'?'Checkout canceled.':T('st.something_went_wrong_with_checkout'));
      ok.classList.remove('d-none'); ok.classList.toggle('alert-success',ret==='success'); ok.classList.toggle('alert-warning',ret!=='success'); }
    var cret=new URLSearchParams(location.search).get('credits');
    if(cret&&g('bill-ok')){ var ok2=g('bill-ok'); ok2.textContent=cret==='success'?'Credits added to your account.':T('st.something_went_wrong_adding_credits');
      ok2.classList.remove('d-none'); ok2.classList.toggle('alert-success',cret==='success'); ok2.classList.toggle('alert-warning',cret!=='success'); }
    renderCreditPacks(d);
    var host=g('bill-plans'); if(!host) return;
    var plans=(d.plans||[]);
    var others=plans.filter(function(p){return p.id!==d.plan_id;});
    if(!others.length){ host.innerHTML=''; if(g('bill-note'))g('bill-note').textContent="You're on our top plan."; return; }

    function hum(n){ n=+n||0; return n>=1e6?((n/1e6).toFixed(n%1e6?1:0)+'M'):n>=1e3?((n/1e3).toFixed(n%1e3?1:0)+'k'):(''+n); }
    function feat(p){
      var f=['Up to '+p.max_sites+' site'+(p.max_sites===1?'':'s'),
             (p.max_events>0?hum(p.max_events)+' events / month':TR('js.unlimited_events')),
             (p.retention_days?p.retention_days+'-day':TR('js.unlimited'))+' data retention'];
      if(p.trial_days) f.unshift(p.trial_days+'-day free trial');
      return f;
    }
    function card(p){
      var current=p.id===d.plan_id;
      var price=p.price_cents>0?money(p.price_cents):T('st.free');
      return '<button type="button" class="up-card'+(current?' current':'')+'" data-plan="'+p.id+'"'+(current?' disabled':'')+'>'
        +'<div class="up-card-head"><span class="up-name">'+p.name+'</span>'
        +(current?'<span class="gs-badge pos">'+T('st.current')+'</span>':'<span class="up-tick" aria-hidden="true"></span>')+'</div>'
        +'<div class="up-price">'+price+(p.price_cents>0?'<small>/mo</small>':'')+'</div>'
        +'<ul class="up-feats">'+feat(p).map(function(x){return '<li>'+x+'</li>';}).join('')+'</ul>'
        +'</button>';
    }

    host.innerHTML=
      '<div class="fw-semibold mb-2">'+T('st.choose_a_plan')+'</div>'
      +'<div class="up-grid">'+plans.map(card).join('')+'</div>'
      +'  <div class="up-coupon"><div class="gs-muted small mb-1">'+T('st.coupon_code')+'</div><input class="form-control" data-gs="up-coupon" placeholder="'+T('st.enter_a_code_optional')+'"><span class="small" data-gs="up-coupon-msg"></span></div>'
      +'<div class="up-foot">'
      +'  <div class="up-pay">'
      +'    <div class="gs-muted small mb-1">'+T('st.payment_method')+'</div>'
      +'    <div class="up-methods" data-gs="up-methods">'
      +'      <button type="button" class="up-method on" data-prov="stripe"><i class="bi bi-credit-card-2-front"></i><span><b>'+TR('js.credit_debit_card')+'</b><small>'+T('st.secure_checkout_via_stripe')+'</small></span></button>'
      +'      <button type="button" class="up-method" data-prov="paypal"><i class="bi bi-paypal"></i><span><b>'+TR('js.paypal')+'</b><small>'+T('st.pay_with_your_paypal_account')+'</small></span></button>'
      +'    </div>'
      +'  </div>'
      +'  <button class="btn btn-primary up-go" data-gs="up-go" disabled>'+T('st.select_a_plan')+'</button>'
      +'</div>';

    var prov='stripe', selected=0, couponData=null;
    var go=host.querySelector('[data-gs="up-go"]');
    var couponEl=host.querySelector('[data-gs="up-coupon"]'), couponMsg=host.querySelector('[data-gs="up-coupon-msg"]');
    function discounted(cents){ if(!couponData) return cents;
      if(couponData.kind==='percent') return Math.max(0,Math.round(cents*(100-couponData.percent_off)/100));
      if(couponData.kind==='fixed')   return Math.max(0,cents-couponData.amount_off_cents); return cents; }
    function updateGo(){ if(!selected){ return; } var pl=others.filter(function(p){return p.id===selected;})[0]; if(!pl) return;
      var c=discounted(pl.price_cents);
      go.disabled=false; go.textContent='Upgrade to '+pl.name+' \u00b7 '+(c>0?money(c)+'/mo':T('st.free'))+((couponData&&c!==pl.price_cents)?(' (was '+money(pl.price_cents)+')'):''); }
    if(couponEl){ var ct; couponEl.addEventListener('input',function(){ clearTimeout(ct); ct=setTimeout(async function(){
      var code=couponEl.value.trim(); couponData=null;
      if(!code){ if(couponMsg)couponMsg.textContent=''; updateGo(); return; }
      var r=await GS.api('/coupon/validate',{method:'POST',body:JSON.stringify({code:code,context:'upgrade'})});
      if(r.ok&&r.data&&r.data.ok){ couponData=r.data.coupon;
        if(couponMsg) couponMsg.textContent=couponData.kind==='percent'?(couponData.percent_off+'% off applied'):couponData.kind==='fixed'?(money(couponData.amount_off_cents)+' off applied'):T('st.coupon_applied');
      } else if(couponMsg){ couponMsg.textContent='That code isn\'t valid.'; }
      updateGo();
    },400); }); }
    var methods=host.querySelector('[data-gs="up-methods"]');
    methods.addEventListener('click',function(e){ var b=e.target.closest('button[data-prov]'); if(!b)return;
      prov=b.dataset.prov; methods.querySelectorAll('.up-method').forEach(function(x){x.classList.toggle('on',x===b);}); });
    host.querySelectorAll('.up-card:not(.current)').forEach(function(c){ c.addEventListener('click',function(){
      selected=+c.dataset.plan;
      host.querySelectorAll('.up-card').forEach(function(x){x.classList.toggle('on',x===c);});
      updateGo();
    }); });

    if(g('bill-note'))g('bill-note').textContent=(d.provider_ready&&(d.provider_ready.stripe||d.provider_ready.paypal))?'Secure checkout by Stripe or PayPal. Cancel anytime.':'Test mode \u2014 checkout is simulated until payment keys are configured.';

    go.addEventListener('click',async function(){
      if(!selected) return;
      go.disabled=true; go.textContent='Redirecting\u2026';
      var cr=await GS.api('/me/billing/checkout',{method:'POST',body:JSON.stringify({plan_id:selected,provider:prov,coupon:couponEl?couponEl.value.trim():''})});
      if(cr.ok&&cr.data&&cr.data.url){ var u=cr.data.url; location.href=(u.charAt(0)==='/'?((GS.apiBase||'')+u):u); }
      else { go.disabled=false; go.textContent='Try again'; }
    });
  }
  /* Credit packs shown under Choose a plan (free plan only — credits buy extra report views). Same
     packs + prices as the in-app Buy-credits popup, laid out as three cards side by side. */
  async function renderCreditPacks(d){
    var host=g('bill-credits'); if(!host) return;
    if((+d.price_cents||0)!==0){ host.innerHTML=''; return; }          // credits only matter on the free plan
    var r=await GS.api('/me/credits/packs'); var cd=(r.ok&&r.data)?r.data:{};
    var packs=(cd.packs&&cd.packs.length)?cd.packs:[{id:'pack_100',credits:100,price_cents:999},{id:'pack_250',credits:250,price_cents:1999},{id:'pack_600',credits:600,price_cents:3999}];
    var bal=+cd.balance||0;
    function card(p){
      return '<div class="col-12 col-md-4"><div class="border rounded p-3 h-100 d-flex flex-column text-center">'
        +'<div class="fw-bold fs-4">'+p.credits+'</div><div class="gs-muted small mb-1">credits</div>'
        +'<div class="fw-semibold mb-3">'+money(p.price_cents)+'</div>'
        +'<button type="button" class="btn btn-primary mt-auto" data-pack="'+p.id+'">Buy</button></div></div>';
    }
    host.innerHTML='<div class="fw-semibold mb-1">'+T('st.credit_packs')+'</div>'
      +'<div class="gs-muted small mb-2">Credits unlock extra report views without upgrading.'+(bal>0?(' You have <b>'+bal+'</b> credits.'):'')+'</div>'
      +'<div class="row g-2">'+packs.map(card).join('')+'</div>'
      +'<div class="gs-muted small mt-2" data-gs="bill-cred-msg"></div>';
    var msg=host.querySelector('[data-gs="bill-cred-msg"]');
    host.querySelectorAll('[data-pack]').forEach(function(b){ b.addEventListener('click',async function(){
      b.disabled=true; b.textContent='\u2026'; if(msg)msg.textContent='';
      var cr=await GS.api('/me/credits/checkout',{method:'POST',body:JSON.stringify({pack:b.dataset.pack,provider:'stripe'})});
      if(cr.ok&&cr.data&&cr.data.url){ var u=cr.data.url; location.href=(u.charAt(0)==='/'?((GS.apiBase||'')+u):u); return; }
      b.disabled=false; b.textContent='Buy';
      var e=(cr.data&&cr.data.error)||''; if(msg)msg.textContent=(e==='stripe_unavailable'||e==='paypal_unavailable')?'Card payments aren\'t enabled yet.':'Couldn\'t start checkout. Please try again.';
    }); });
  }
  async function loadInvoices(){ var tb=g('inv-rows'); if(!tb)return; var r=await GS.api('/me/invoices'); var inv=(r.ok&&r.data&&r.data.invoices)||[];
    tb.innerHTML = inv.length ? inv.map(function(i){ return '<tr><td>'+i.number+'</td><td>'+(i.created_at||'').slice(0,10)+'</td><td class="r">'+money(i.amount_cents,i.currency)+'</td><td><span class="gs-badge">'+i.status+'</span></td><td class="r">'+(i.pdf_url?'<a href="'+i.pdf_url+'">PDF</a>':'')+'</td></tr>' }).join('')
      : '<tr><td colspan="5" class="text-center gs-muted">'+T('st.no_invoices_yet')+'</td></tr>'; }
  async function loadAddress(){ var r=await GS.api('/me/address'); if(!(r.ok&&r.data))return; ['company','address1','address2','city','region','postal','country','vat'].forEach(function(k){ var el=g('addr-'+k); if(el) el.value=r.data[k]||''; }); }
  function initAddressSave(){ var b=g('addr-save'); if(!b)return; b.addEventListener('click',async function(){ show(g('addr-ok'),false);
    var body={}; ['company','address1','address2','city','region','postal','country','vat'].forEach(function(k){ body[k]=(g('addr-'+k)||{}).value||'' });
    var r=await GS.api('/me/address',{method:'POST',body:JSON.stringify(body)}); if(r.ok) show(g('addr-ok'),true); }); }

  /* ---- email reports (per site or all) ---- */
  var repData={reports:[],sites:[],paid:true};
  function repState(scope){ var m={}; repData.reports.forEach(function(r){ if(+r.site_id===+scope) m[r.frequency]=+r.enabled; }); return m; }
  function paintReports(){ var scope=+(g('rep-scope')||{value:0}).value||0, st=repState(scope);
    GSUI.qa('[data-rep]').forEach(function(t){
      var locked = !repData.paid && (t.dataset.rep==='daily'||t.dataset.rep==='weekly');   // daily+weekly are Pro
      if(locked){ t.checked=false; t.disabled=true; } else { t.disabled=false; t.checked=!!st[t.dataset.rep]; }
    }); }
  function lockRepRow(freq){
    var t=GSUI.q('[data-rep="'+freq+'"]'); if(!t) return;
    var row=t.closest('.border-bottom')||t.closest('.d-flex'); if(!row) return;
    var title=row.querySelector('.fw-semibold');
    if(title && !title.querySelector('.gs-rep-pro')) title.insertAdjacentHTML('beforeend',' <span class="gs-rep-pro badge rounded-pill" style="background:var(--accent-soft);color:var(--accent-2)">'+TR('js.pro')+'</span>');
  }
  async function loadReports(){ var sel=g('rep-scope'); if(!sel)return; var r=await GS.api('/me/email-reports'); if(!(r.ok&&r.data))return;
    repData=r.data; sel.innerHTML='<option value="0">'+T('st.all_sites')+'</option>'+ (repData.sites||[]).map(function(s){return '<option value="'+s.id+'">'+s.name+'</option>'}).join('');
    paintReports();
    if(!repData.paid){ lockRepRow('daily'); lockRepRow('weekly'); if(g('rep-pro-note'))g('rep-pro-note').classList.remove('d-none'); }
    else if(g('rep-pro-note')) g('rep-pro-note').classList.add('d-none');
    sel.onchange=paintReports;
    GSUI.qa('[data-rep]').forEach(function(t){ if(t._w)return; t._w=1; t.addEventListener('change',async function(){
      var scope=+sel.value||0; var r2=await GS.api('/me/email-reports',{method:'POST',body:JSON.stringify({site_id:scope,frequency:t.dataset.rep,enabled:t.checked})});
      var d2=r2&&r2.data;
      if(r2.ok&&d2&&d2.ok){
        /* Reflect what the server says it stored, not what we hoped. */
        /* Trust the server's echo when it sends one; otherwise keep what the user just chose. An older
           API build (or a cached response) has no `enabled` field, and flipping the toggle off in that
           case would look exactly like a failed save. */
        var on = (d2.enabled === undefined || d2.enabled === null) ? t.checked : !!+d2.enabled;
        t.checked = on;
        var found=false; repData.reports.forEach(function(x){ if(+x.site_id===scope&&x.frequency===t.dataset.rep){x.enabled=on?1:0;found=true;} });
        if(!found) repData.reports.push({site_id:scope,frequency:t.dataset.rep,enabled:on?1:0});
        if(g('rep-status')){ g('rep-status').textContent=on?'Saved.':'Turned off.'; setTimeout(function(){g('rep-status').textContent=''},1800); } }
      else { t.checked=false;                                        // pro_required (or other) -> revert
        var msg='Could not save.';
        if(d2&&d2.error==='pro_required') msg='Daily and weekly reports are a Pro feature.';
        else if(d2&&d2.error==='save_failed') msg='Could not save \u2014 '+(d2.detail||'server error');
        else if(d2&&d2.error) msg='Could not save ('+d2.error+').';
        if(g('rep-status')) g('rep-status').textContent=msg; }
    }); });
  }

  /* ---- tracking: self-exclusion IPs ---- */
  async function loadTracking(){
    var r=await GS.api('/me/tracking'); if(r.ok&&r.data&&g('trk-ips')) g('trk-ips').value=r.data.excluded_ips||'';
    var ip=await GS.api('/me/my-ip'); if(ip.ok&&ip.data&&g('trk-myip-val')) g('trk-myip-val').textContent=ip.data.ip||'—';
    var my=g('trk-myip'); if(my&&!my._w){ my._w=1; my.addEventListener('click',function(){ var v=(g('trk-myip-val').textContent||'').trim(); if(!v||v==='—')return; var ta=g('trk-ips'); var lines=(ta.value||'').split(/\s+/).filter(Boolean); if(lines.indexOf(v)<0){ lines.push(v); ta.value=lines.join('\n'); } }); }
    var s=g('trk-save'); if(s&&!s._w){ s._w=1; s.addEventListener('click',async function(){ show(g('trk-ok'),false); var r2=await GS.api('/me/tracking',{method:'POST',body:JSON.stringify({excluded_ips:g('trk-ips').value})}); if(r2.ok){ if(r2.data) g('trk-ips').value=r2.data.excluded_ips||''; show(g('trk-ok'),true); } }); }
  }

  /* ---- counter on/off + clickable ---- */
  async function saveCounter(){ var r=await GS.api('/me/tracking',{method:'POST',body:JSON.stringify({excluded_ips:(g('trk-ips')||{}).value||GS._exips||'', counter_enabled:g('cnt-enabled').checked, counter_clickable:g('cnt-clickable').checked})}); if(r.ok){ show(g('cnt-ok'),true); setTimeout(function(){show(g('cnt-ok'),false)},2500); } }
  async function loadCounter(){
    var r=await GS.api('/me/tracking'); if(!(r.ok&&r.data))return; GS._exips=r.data.excluded_ips||'';
    if(g('cnt-enabled')) g('cnt-enabled').checked=!!r.data.counter_enabled;
    if(g('cnt-clickable')) g('cnt-clickable').checked=!!r.data.counter_clickable;
    /* Free accounts: the counter and the clickable counter are always on (server rule FreeListing, sent as listing_locked). */
    var locked=!!+r.data.listing_locked;
    ['cnt-enabled','cnt-clickable'].forEach(function(k){ var el=g(k); if(!el)return; if(locked){ el.checked=true; el.disabled=true; } else el.disabled=false; });
    if(g('cnt-clickable-note')) g('cnt-clickable-note').classList.toggle('d-none',!locked);
    ['cnt-enabled','cnt-clickable'].forEach(function(k){ var el=g(k); if(el&&!el._w){ el._w=1; el.addEventListener('change',function(){ show(g('cnt-ok'),false); saveCounter(); }); } });
  }

  /* ---- insights (pro-gated) ---- */
  async function loadInsights(){
    var el=g('ins-forecast-state'); if(!el) return;
    var r=await GS.api('/me/billing'); var pro=r.ok&&r.data&&(+r.data.price_cents>0);
    el.innerHTML = pro
      ? '<span class="text-success fw-semibold"><i class="bi bi-check-circle-fill"></i> Enabled</span>'
      : '<a class="btn btn-primary btn-sm" href="/user-settings#billing" onclick="document.querySelector(\'[data-sec=billing]\').click();return false;">'+TR('js.upgrade_to_pro')+'</a>';
  }

  /* ---- affiliate ---- */
  var AFF={rate:15,avail:0};
  async function loadAffiliate(){
    var r=await GS.api('/me/affiliate'); if(!(r.ok&&r.data)) return; var d=r.data;
    if(g('aff-rate'))g('aff-rate').textContent=Math.round(d.rate_bps/100)+'%';
    if(g('aff-link'))g('aff-link').value=d.link;
    if(g('aff-referrals'))g('aff-referrals').textContent=d.referrals;
    if(g('aff-available'))g('aff-available').textContent=money(d.balance_cents);
    if(g('aff-earned'))g('aff-earned').textContent=money(d.earned_cents);
    if(g('aff-paid'))g('aff-paid').textContent=money(d.paid_cents);
    if(g('aff-min'))g('aff-min').textContent=money(d.min_payout_cents);
    // convert-earnings state
    AFF.rate = +d.credits_per_dollar || 15;
    AFF.avail = +d.balance_cents || 0;
    if(g('aff-cpr'))g('aff-cpr').textContent=AFF.rate;
    if(g('aff-credits'))g('aff-credits').textContent=(+d.credit_balance||0);
    if(g('aff-billing'))g('aff-billing').textContent=money(d.billing_credit_cents);
    var cw=g('aff-conv-wrap'), cr=g('aff-conv-rows');
    if(cr){ cr.innerHTML=(d.conversions&&d.conversions.length)?d.conversions.map(function(c){
      var got=c.destination==='credits'?((+c.credits)+' credits'):(money(c.amount_cents)+' billing');
      return '<tr><td>'+got+'</td><td class="text-end gs-muted small">'+money(c.amount_cents)+'</td><td class="text-end gs-muted small">'+(c.created_at||'').slice(0,10)+'</td></tr>';
    }).join(''):''; }
    if(cw) cw.hidden = !(d.conversions&&d.conversions.length);
    var rows=g('aff-rows'); if(rows){ rows.innerHTML=(d.commissions&&d.commissions.length)?d.commissions.map(function(c){
      return '<tr><td>'+c.referred+'</td><td class="text-end">'+money(c.commission_cents)+'</td><td class="text-end gs-muted small">'+(c.created_at||'').slice(0,10)+'</td></tr>';
    }).join(''):'<tr><td class="gs-muted small">'+T('st.no_commissions_yet')+'</td></tr>'; }
  }
  function initAffiliate(){
    var cp=g('aff-copy'); if(cp) cp.addEventListener('click',function(){ var i=g('aff-link'); if(!i)return; i.select();
      if(navigator.clipboard) navigator.clipboard.writeText(i.value); else { try{document.execCommand('copy');}catch(e){} }
      cp.textContent='Copied'; setTimeout(function(){cp.textContent='Copy';},1200); });
    var pb=g('aff-payout'); if(pb) pb.addEventListener('click',async function(){ var msg=g('aff-msg'); var dest=(g('aff-dest')||{}).value||'';
      var r=await GS.api('/me/affiliate/payout',{method:'POST',body:JSON.stringify({destination:dest})});
      if(msg){ msg.classList.remove('d-none','alert-success','alert-warning');
        if(r.ok&&r.data&&r.data.ok){ msg.textContent='Payout of '+money(r.data.amount_cents)+' requested.'; msg.classList.add('alert-success'); loadAffiliate(); }
        else { var e=r.data&&r.data.error; msg.textContent=e==='below_minimum'?('You need at least '+money((r.data&&r.data.min_payout_cents)||5000)+' to withdraw.'):(e==='bad_destination'?'Enter a valid PayPal email.':T('st.could_not_request_payout')); msg.classList.add('alert-warning'); }
      }
    });
    // convert earnings -> credits or billing balance
    var amt=g('aff-conv-amt');
    function hint(){ var h=g('aff-conv-hint'); if(!h)return; var d=parseFloat((amt&&amt.value)||'0')||0;
      h.textContent = d>0 ? ('= '+Math.floor(d*AFF.rate)+' credits, or '+('$'+d.toFixed(2))+' billing balance.') : ''; }
    if(amt) amt.addEventListener('input',hint);
    function convert(to){ var msg=g('aff-conv-msg'); if(!msg)return;
      var d=parseFloat((amt&&amt.value)||'0')||0; var cents=Math.round(d*100);
      msg.classList.remove('d-none','alert-success','alert-warning');
      if(cents<=0){ msg.textContent='Enter an amount to convert.'; msg.classList.add('d-none'); if(amt)amt.focus(); return; }
      if(cents>AFF.avail){ msg.textContent="That's more than your available "+money(AFF.avail)+'.'; msg.classList.add('alert-warning'); return; }
      GS.api('/me/affiliate/convert',{method:'POST',body:JSON.stringify({to:to,amount_cents:cents})}).then(function(r){
        var x=r&&r.data; msg.classList.remove('d-none','alert-success','alert-warning');
        if(x&&x.ok){
          msg.textContent = to==='credits'
            ? ('Converted '+money(x.amount_cents)+' to '+x.credits+' credits \u2014 you now have '+x.credit_balance+'.')
            : ('Added '+money(x.amount_cents)+' to your billing balance.');
          msg.classList.add('alert-success'); if(amt)amt.value=''; hint(); loadAffiliate();
        } else {
          var e=x&&x.error;
          msg.textContent = e==='insufficient' ? ("That's more than your available balance.")
            : e==='amount_too_small' ? ('Too small \u2014 that converts to less than one credit.')
            : e==='bad_amount' ? (T('st.enter_an_amount_to_convert'))
            : (T('st.could_not_convert_right_now'));
          msg.classList.add('alert-warning');
        }
      }).catch(function(){ msg.textContent='Could not convert right now.'; msg.classList.remove('d-none'); msg.classList.add('alert-warning'); });
    }
    var cc=g('aff-conv-credits'); if(cc) cc.addEventListener('click',function(){convert('credits');});
    var cbn=g('aff-conv-billing'); if(cbn) cbn.addEventListener('click',function(){convert('billing');});
  }

  /* ---- delete account ---- */
  function initDelete(){ var inp=g('del-confirm'), btn=g('del-btn'); if(!inp||!btn)return;
    function expect(){ return (GS.user.name||GS.user.email||'').trim().toLowerCase() }
    inp.addEventListener('input',function(){ btn.disabled = inp.value.trim().toLowerCase()!==expect(); });
    btn.addEventListener('click',async function(){ show(g('del-error'),false);
      var r=await GS.api('/me/delete',{method:'POST',body:JSON.stringify({confirm:inp.value})});
      if(r.ok){ location.href='/login'; } else { g('del-error').textContent='Confirmation did not match.'; show(g('del-error'),true); } });
  }

  function boot(){ if(!GS.user) return; loadProfile(); }
  document.addEventListener('DOMContentLoaded',function(){ initNav(); initAvatar(); initProfileSave(); initAddressSave(); initDelete(); initAffiliate();
  document.querySelectorAll('[data-goto]').forEach(function(a){ a.addEventListener('click',function(e){ e.preventDefault(); var n=document.querySelector('.gs-settings-nav a[data-sec="'+a.dataset.goto+'"]'); if(n)n.click(); }); }); });
  document.addEventListener('gs:ready', boot);
  if(window.GS&&GS.user) boot();
})();

/* ── The GhostStat Chronicle delivery settings ── */
(function(){
  function q(s){ return document.querySelector(s); }
  function status(msg){ var el=q('[data-gs="chron-status"]'); if(el) el.textContent=msg||''; }

  async function loadChronicle(){
    if(!q('[data-gs="chronicle-card"]')) return;
    var r = await GS.api('/account/chronicle');
    if(!r.ok || !r.data) return;
    var d = r.data;
    // scope dropdown: All sites (0) + each site
    var sc = q('[data-chron-scope]');
    if(sc){ sc.innerHTML = '<option value="0">'+(sc.querySelector('option')?sc.querySelector('option').textContent:T('st.all_sites_portfolio'))+'</option>'
              + (d.sites||[]).map(function(s){return '<option value="'+s.id+'">'+s.name+'</option>'}).join('');
            // reflect the saved scope (use morning's, they share)
            var savedScope = (d.morning&&d.morning.site_id)||0; sc.value = String(savedScope); }
    ['morning','evening','weekly'].forEach(function(ed){
      var on = q('[data-chron-on="'+ed+'"]'); if(on && d[ed]) on.checked = !!d[ed].enabled;
      var hr = q('[data-chron-hour="'+ed+'"]'); if(hr && d[ed] && d[ed].send_hour!=null) hr.value = d[ed].send_hour;
    });
    // weekend_only + pause are global-ish (read from morning row + user)
    var wk = q('[data-chron-weekend]'); if(wk) wk.checked = !!(d.morning && d.morning.weekend_only);
    var pz = q('[data-chron-pause]'); if(pz) pz.checked = !!d.paused;
  }

  async function saveEdition(ed){
    var enabled = (q('[data-chron-on="'+ed+'"]')||{}).checked || false;
    var hourEl = q('[data-chron-hour="'+ed+'"]');
    var send_hour = hourEl ? parseInt(hourEl.value,10) : null;
    var weekend_only = (q('[data-chron-weekend]')||{}).checked || false;
    var site_id = parseInt((q('[data-chron-scope]')||{}).value||'0',10) || 0;
    status(T('st.saving'));
    var r = await GS.api('/account/chronicle',{method:'POST',
      body:JSON.stringify({edition:ed, enabled:enabled, send_hour:send_hour, weekend_only:weekend_only, site_id:site_id})});
    status(r.ok ? 'Saved.' : T('st.could_not_save'));
  }

  function bind(){
    if(!q('[data-gs="chronicle-card"]')) return;
    ['morning','evening','weekly'].forEach(function(ed){
      var on=q('[data-chron-on="'+ed+'"]'); if(on) on.addEventListener('change', function(){ saveEdition(ed); });
      var hr=q('[data-chron-hour="'+ed+'"]'); if(hr) hr.addEventListener('change', function(){ saveEdition(ed); });
    });
    // weekend toggle re-saves all enabled editions (it's a shared flag stored per row)
    var wk=q('[data-chron-weekend]');
    if(wk) wk.addEventListener('change', function(){ ['morning','evening','weekly'].forEach(saveEdition); });
    var sc=q('[data-chron-scope]');
    if(sc) sc.addEventListener('change', function(){ ['morning','evening','weekly'].forEach(saveEdition); });
    // pause is a single global call
    var pz=q('[data-chron-pause]');
    if(pz) pz.addEventListener('change', async function(){
      status(T('st.saving'));
      var r=await GS.api('/account/chronicle',{method:'POST',body:JSON.stringify({paused:pz.checked})});
      status(r.ok ? (pz.checked?'Chronicle paused.':T('st.chronicle_resumed')) : T('st.could_not_save'));
    });
  }

  document.addEventListener('gs:ready', function(){ loadChronicle(); bind(); });
  document.addEventListener('DOMContentLoaded', function(){ loadChronicle(); bind(); });
})();
